import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import Services from "../pages/Services";
import Contact from "../pages/Contact";
import Membership from "../pages/Membership";
import PageNotFound from "../pages/PageNotFound";
import MembershipRegistration from "../pages/MembershipRegistration";
import Login from "../pages/Login";
import PaymentCheckout from "../pages/PaymentCheckout";
import ImageGallery from "../pages/ImageGallery";
import OurMission from "../pages/OurMission";
import OurVision from "../pages/OurVision";
import OurLeadersipTeam from "../pages/OurLeadersipTeam";
import VideoGallery from "../pages/VideoGallery";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import PresentEvents from "../pages/PresentEvents";
import PastEvents from "../pages/PastEvents";
import Sponsors from "../pages/Sponsors";
import Restaurant from "../pages/Restaurant";
import ConventionHall from "../pages/ConventionHall";
import CategoryDetails from "../pages/CategoryDetails";
import ReviewRestaurant from "../pages/ReviewRestaurant";
import UpcomingEvents from "../pages/UpcomingEvents";
import ProShop from "../pages/ProShop";
import GolfCourse from "../pages/GolfCourse";
import EventDetailsPage from "../pages/EventDetailsPage";
import FacilitiesForGuests from "../pages/FacilitiesForGuests";
import FacilitiesForMembers from "../pages/FacilitiesForMembers";
// import VerifyEmail from "../pages/VerifyEmail";
import EmailVerifiedNotice from "../pages/EmailVerifiedNotice";
import ProtectedRoute from "../components/ProtectedRoute";
import MemberDashboard from "../pages/MemberDashboard";
import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import GolfStatisticsDashboard from "../pages/GolfStatisticsDashboard";
import GuestRoom from "../pages/GuestRoom";
import Profile from "../pages/Profile";
import MembershipDetails from "../pages/MembershipDetails";
import MenuGallery from "../pages/MenuGallery";

const AppRouter = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  // const sortedEvents = sortEventsByDate(events);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await api.get("/events/get/all");
        setEvents(res.data);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingEvents = events.filter((event) => {
    // if (e.eventType) return e.eventType === "UPCOMING_EVENT";
    // return new Date(e.startDate) > today;
    if (!event.active) return false; // Optional: skip inactive events
    const eventStartDate = new Date(event.startDate);
    eventStartDate.setHours(0, 0, 0, 0);
    return eventStartDate > today; // Event starts in the future
  });

  const presentEvents = events.filter((event) => {
    // if (e.eventType) return e.eventType === "PRESENT_EVENT";
    // return new Date(e.startDate) <= today && new Date(e.endDate) >= today;
    if (!event.active) return false; // Optional: skip inactive events
    const eventStartDate = new Date(event.startDate);
    const eventEndDate = new Date(event.endDate);
    eventStartDate.setHours(0, 0, 0, 0);
    eventEndDate.setHours(23, 59, 59, 999); // Include full end day

    // Event is currently happening (today is between start and end dates)
    return today >= eventStartDate && today <= eventEndDate;
  });

  const pastEvents = events.filter((event) => {
    // if (e.eventType) return e.eventType === "PAST_EVENT";
    // return new Date(e.endDate) < today;
    if (!event.active) return false; // Optional: skip inactive events
    const eventEndDate = new Date(event.endDate);
    eventEndDate.setHours(23, 59, 59, 999); // Include full end day
    return eventEndDate < today; // Event ended in the past
  });

  // Optional: Sort events within each category
  const sortEvents = (eventsArray, order = "asc") => {
    return [...eventsArray].sort((a, b) => {
      const dateA = new Date(a.startDate);
      const dateB = new Date(b.startDate);
      return order === "asc" ? dateA - dateB : dateB - dateA;
    });
  };

  // Sort upcoming events by start date (ascending - soonest first)
  const sortedUpcomingEvents = sortEvents(upcomingEvents, "asc");

  // Sort present events by start date (ascending)
  const sortedPresentEvents = sortEvents(presentEvents, "asc");

  // Sort past events by start date (descending - most recent first)
  const sortedPastEvents = sortEvents(pastEvents, "desc");

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/mission" element={<OurMission />} />
      <Route path="/vision" element={<OurVision />} />
      <Route path="/leadership-team" element={<OurLeadersipTeam />} />

      <Route path="/services" element={<Services />} />
      <Route path="/restaurant" element={<Restaurant />} />
      <Route path="/menu-gallery" element={<MenuGallery />} />
      <Route path="/guest-room" element={<GuestRoom />} />
      <Route path="pro-shop" element={<ProShop />} />
      <Route path="/review" element={<ReviewRestaurant />} />
      <Route path="/category/:id" element={<CategoryDetails />} />
      <Route path="/convention-hall" element={<ConventionHall />} />
      <Route path="/golf-course" element={<GolfCourse />} />

      {/* <Route path="/image-gallery" element={<Gallery />} /> */}
      <Route path="/image-gallery" element={<ImageGallery />} />
      <Route path="/video-gallery" element={<VideoGallery />} />
      <Route path="/contact" element={<Contact />} />

      <Route path="/membership" element={<Membership />} />
      <Route
        path="/membership-registration"
        element={<MembershipRegistration />}
      />

      {/* events */}
      <Route
        path="/present-events"
        element={
          <PresentEvents
            events={sortedPresentEvents}
            title={"Present Events"}
          />
        }
      />
      <Route
        path="/past-events"
        element={<PastEvents events={sortedPastEvents} title={"Past Events"} />}
      />
      <Route
        path="/upcoming-events"
        element={
          <UpcomingEvents
            events={sortedUpcomingEvents}
            title={"Upcoming Events"}
          />
        }
      />

      <Route path="/sponsors" element={<Sponsors />} />

      <Route path="/facilites-guests" element={<FacilitiesForGuests />} />
      <Route path="/facilites-members" element={<FacilitiesForMembers />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <MemberDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />

      <Route
        path="/membership-details"
        element={
          <ProtectedRoute>
            <MembershipDetails />
          </ProtectedRoute>
        }
      />

      {/* Add Golf Statistics Route */}
      <Route
        path="/golf-statistics"
        element={
          <ProtectedRoute>
            <GolfStatisticsDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/payment-checkout"
        element={
          <ProtectedRoute>
            <PaymentCheckout />
          </ProtectedRoute>
        }
      />

      <Route
        path="/events/:id"
        element={<EventDetailsPage events={events} />}
      />

      <Route path="/email-verified" element={<EmailVerifiedNotice />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRouter;
